module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b39a8dcd1214babeefc01549921e89c.png";